import React from 'react';
import MuiMultiSelectionDropDown from '@shared/components/MuiMultiSelectionDropDown';

/**
 * @typedef {object} MuiMultiMaxSelectionDropDownOption
 * @property {string} label
 * @property {number|string} value
 * @property {boolean} [disabled]
 */

/**
 * @typedef {object} MuiMultiMaxSelectionDropDownOwnProps
 * @property {Array<MuiMultiMaxSelectionDropDownOption>} [options]
 * @property {(selectedValues: Array<MuiMultiMaxSelectionDropDownOption>) => void} [setSelectedValues]
 * @property {Array<MuiMultiMaxSelectionDropDownOption>} [selectedValues]
 * @property {boolean} [enabled]
 * @property {number} [maxSelection]
 */

/**
 * @typedef {MuiMultiMaxSelectionDropDownOwnProps &
 *   React.ComponentProps<typeof MuiMultiSelectionDropDown>} MuiMultiMaxSelectionDropDownProps
 */

/**
 * @param {MuiMultiMaxSelectionDropDownProps} props
 */
const MuiMultiMaxSelectionDropDown = props => {
  const { options, enabled, selectedValues, setSelectedValues, maxSelection, ...otherProps } =
    props;

  const selectableOptions =
    selectedValues.length === maxSelection
      ? options.map(option => ({
          ...option,
          disabled: !selectedValues.some(selected => selected.value === option.value)
        }))
      : options;

  return (
    <MuiMultiSelectionDropDown
      {...otherProps}
      disabled={!enabled}
      options={selectableOptions}
      setSelectedValue={setSelectedValues}
      selectedValues={selectedValues}
    />
  );
};

export default MuiMultiMaxSelectionDropDown;
